import { render, staticRenderFns } from "./PreferenceAccountInventory.vue?vue&type=template&id=eb1b4904&"
import script from "./PreferenceAccountInventory.vue?vue&type=script&lang=ts&"
export * from "./PreferenceAccountInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb1b4904')) {
      api.createRecord('eb1b4904', component.options)
    } else {
      api.reload('eb1b4904', component.options)
    }
    module.hot.accept("./PreferenceAccountInventory.vue?vue&type=template&id=eb1b4904&", function () {
      api.rerender('eb1b4904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferenceAccountInventory.vue"
export default component.exports